import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@shared/shared/tokens/window';
import { distinctUntilChanged, fromEvent, map, Observable, shareReplay, startWith } from 'rxjs';

export enum BreakPoints {
  MOBILE = 768,
  TABLET = 1024,
}

@Injectable({ providedIn: 'root' })
export class PlatformService {
  constructor(@Inject(WINDOW) private window: Window) {}

  public readonly windowHeight$ = fromEvent(this.window, 'resize').pipe(
    startWith(<any>undefined),
    map(() => this.window.innerHeight)
  );

  public breakPointChange$(breakpoint: BreakPoints | number): Observable<boolean> {
    return fromEvent(this.window, 'resize').pipe(
      startWith(<any>undefined),
      map(() => this.window.innerWidth < breakpoint),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
